/**
 * Featured Gear Section - Quick View Handler
 */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Find all featured gear sections on the page
  const featuredGearSections = document.querySelectorAll('[data-section-type="featured-gear"]');
  
  featuredGearSections.forEach(function(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const carouselEl = document.getElementById('featured-gear-' + sectionId);
    const modal = document.getElementById('modal-quick-view-' + sectionId);
    
    // Initialize carousel
    if (carouselEl && typeof Swiper !== 'undefined') {
      new Swiper(carouselEl, {
        slidesPerView: 1.3,
        spaceBetween: 16,
        loop: false,
        simulateTouch: true,
        allowTouchMove: true,
        grabCursor: true,
        pagination: {
          el: carouselEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          768: { slidesPerView: 2.1 },
          1024: { slidesPerView: 3.1 },
          1320: { slidesPerView: 4.1 },
        }
      });
    }

    // Clear modal content when closed
    if (modal) {
      modal.addEventListener('modal:closed', function() {
        setTimeout(function() {
          modal.querySelector('.modal__inner').innerHTML = '';
        }, 300);
      });
    }

    // Quick View handler
    const quickViewButtons = sectionEl.querySelectorAll('[data-secondary-action="open-quick-view"]');
    
    quickViewButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        // Wait for modal to open, then load content
        setTimeout(function() {
          if (!modal) return;
          
          const productUrl = button.getAttribute('data-product-url');
          
          // Check if modal is open
          if (modal.getAttribute('aria-hidden') === 'false') {
            // Always fetch fresh content
            modal.classList.add('is-loading');
            modal.querySelector('.modal__inner').innerHTML = '';
            
            fetch(productUrl + '?view=quick-view', { 
              credentials: 'same-origin' 
            })
            .then(function(response) {
              if (!response.ok) throw new Error('Network error');
              return response.text();
            })
            .then(function(content) {
              modal.querySelector('.modal__inner').innerHTML = content;
              modal.classList.remove('is-loading');
              
              // Initialize product section
              if (typeof ProductSection !== 'undefined') {
                const modalProductSection = new ProductSection(
                  modal.querySelector('[data-section-type="product"]')
                );
                
                modal.addEventListener('modal:closed', function cleanUp() {
                  modalProductSection.onUnload();
                  modal.removeEventListener('modal:closed', cleanUp);
                });
              }
            })
            .catch(function(error) {
              console.error('Quick view error:', error);
              modal.classList.remove('is-loading');
            });
          }
        }, 100);
      });
    });
  });
});
